import { render, staticRenderFns } from "./other.vue?vue&type=template&id=756e6a84&"
import script from "./other.vue?vue&type=script&lang=js&"
export * from "./other.vue?vue&type=script&lang=js&"
import style0 from "./other.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/nsdua/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('756e6a84')) {
      api.createRecord('756e6a84', component.options)
    } else {
      api.reload('756e6a84', component.options)
    }
    module.hot.accept("./other.vue?vue&type=template&id=756e6a84&", function () {
      api.rerender('756e6a84', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "frontend/page/_home/other.vue"
export default component.exports